import React, { FC } from 'react';

import { Classification, ParentalControl } from '@skytvnz/sky-app-store/lib/types/graph-ql';
import { selectors } from '@/Store';
import { useSelector } from 'react-redux';
import { formatClassification } from '@/Utils/Rating';
import CreatePinPanel from './CreatePinPanel';
import EnterPinPanel from './EnterPinPanel';

export interface ParentalControlPanelProps {
  playerReferrer?: string;
  contentClassification?: Classification;
  onParentalResolved(): void;
}

const ParentalControlPanel: FC<ParentalControlPanelProps> = ({
  playerReferrer,
  contentClassification,
  onParentalResolved,
}) => {
  const getCreatePinDescription = (): JSX.Element => {
    return (
      <>
        {`This content is rated as ${formatClassification(
          contentClassification,
        )}+. Please create your Parental Control PIN.
      You can adjust it any time via My Account settings on `}
        <strong>sky.co.nz</strong>
      </>
    );
  };
  const getEnterPinDescription = (): string => {
    return `${
      contentClassification
        ? `This content is rated as ${formatClassification(contentClassification)}.`
        : `This content is unrated.`
    } Please enter your Parental Control PIN.`;
  };

  const parentalControl = useSelector(selectors.parentalPin.parentalControl);

  return parentalControl === ParentalControl.NotSet ? (
    <CreatePinPanel
      onPinCreated={onParentalResolved}
      pageReferrer={playerReferrer}
      description={getCreatePinDescription()}
      isVideoPlayerPage
    />
  ) : (
    <EnterPinPanel
      onPinEntered={onParentalResolved}
      pageReferrer={playerReferrer}
      description={getEnterPinDescription()}
      isVideoPlayerPage
    />
  );
};

export default ParentalControlPanel;
